function parse_utm_data() {
  var url = new URL(window.location.href);
  var paramsToStore = [
    'utm_campaign',
    'utm_content',
    'utm_medium',
    'utm_source',
    'utm_term',
    'utm_adgroupid',
    'utm_campaignid',
    'utm_creative',
    'utm_device',
    'gclid',
    'utm_keyword',
    'utm_matchtype',
    'utm_network',
    'utm_targetid',
    'li_fat_id',
    'msclkid',
    'fbclid',
    'channel_type',
    'utm_gclid',
    'utm_adgroup',
    'leadsource',
    'ft_utm_campaign',
    'ft_utm_content',
    'ft_utm_medium',
    'ft_utm_source',
    'ft_utm_term',
    'ft_utm_adgroupid',
    'ft_utm_campaignid',
    'ft_utm_creative',
    'ft_utm_device',
    'ft_gclid',
    'ft_utm_keyword',
    'ft_utm_matchtype',
    'ft_utm_network',
    'ft_utm_targetid',
    'ft_li_fat_id',
    'ft_msclkid',
    'ft_fbclid',
    'ft_channel_type',
    'ft_sfcid',
    'whitepaper',
    'honeypot',
    'CampaignId',
    'status',
    'leadsource',
    'ft_utm_source',
    'ft_utm_medium',
    'ft_utm_campaign',
    'Chilipiper_Campaign_Member_Status',
    'chilipiper_meeting_topic',
    'Chilipiper_CampaignID',
  ];
  for(var i in paramsToStore) {
    if(!!url.searchParams.get(paramsToStore[i])) {
      window.localStorage.setItem(paramsToStore[i], url.searchParams.get(paramsToStore[i]));
    }
  }
  var currentReferrer = document.referrer || 'null';
  var refDomains = {
    '://google.com ': ['google', 'organic'],
    '://bing.com ': ['bing', 'organic'],
    '://linkedin.com ': ['linkedin', 'organic'],
    'x.com': ['x', 'organic'],
    '://instagram.com ': ['instagram', 'organic'],  
    '://facebook.com ': ['facebook', 'organic'],
    '://greensheet.com ': ['greensheet', 'referral'],
    '://yahoo.com ': ['yahoo', 'organic'],
    'reddit.com': ['reddit', 'organic']
  };

  var ft_utm_Source = 'Web';
  var ft_utm_Medium = 'direct';
  for (var domain in refDomains) {
    if (currentReferrer.includes(domain)) {
      ft_utm_Source = refDomains[domain][0];
      ft_utm_Medium = refDomains[domain][1];
    }
  }

  if(!!window.localStorage.getItem('ft_utm_Source')){
    window.localStorage.setItem('ft_utm_Source', ft_utm_Source);
  }

  if(!!window.localStorage.getItem('ft_utm_Medium')){
    window.localStorage.setItem('ft_utm_Medium', ft_utm_Medium);
  }
}

function prepare_featured_bar(){
  var elements = document.querySelectorAll('.featured-bar');
  if(elements.length ) {
    var element = elements[0];
    if(!window.localStorage.getItem('closed_bar_' + element.dataset.id)) {
      element.classList.add('show');
      document.body.classList.add('with-featured-bar');
    }
  }
}

parse_utm_data();

prepare_featured_bar();

function rotate_menu_banners() {
  var newVersion = false;
  $('.rotating-banner').each(function(i, element){
    var content = $(element).data('content');
    var hash = $(element).data('hash');
    var storedHash = window.localStorage.getItem('rotating_banner_' + i + '_hash') || '0';
    if(hash == storedHash) {
      var index = window.localStorage.getItem('rotating_banner_' + i + '_lastItem') || -1;
    } else {
      var index = -1;
    }
    index++;
    if(index >= content.length) {
      index = 0;
    }
    var item = content[index];
    var html = '';
    if ( item.header && item.text ) {
      html += '<div class="mega-menu-right' + (item.overlay ? ' overlay' : '') + '">';
      if(item.image !== null) {
        html += '<div class="menu-img-bottom d-xl-none"><img class="" width="'+item.image.width+'" height="'+item.image.height+'" alt="'+item.image.alt+'" src="'+item.image.url+'"></div>';
      }
      html += '<div class="menu-text-top-right ' + item.color + '">';
      html += '<div class="h3">' + item.header + '</div>';
      html += '<p>' + item.text + '</p>';
      if(item.link) {
        html += '<a href="'+item.link.url+'" class="learn-more">' + item.link.title +'</a>';
      }
      html += '</div>';
      if(item.image !== null) {
        html += '<div class="menu-img-bottom d-none d-xl-block"><img class="" width="'+item.image.width+'" height="'+item.image.height+'" alt="'+item.image.alt+'" src="'+item.image.url+'"></div>';
      }
      html += '</div>';
    }
    $(element).replaceWith(html);
    window.localStorage.setItem('rotating_banner_' + i + '_hash', hash);
    window.localStorage.setItem('rotating_banner_' + i + '_lastItem', index);
  });
}

$(document).ready(function () {

  rotate_menu_banners();

  $('.featured-bar').each(function(){
    $(this).find('.close-bar').click(function(){
      var element = $('.featured-bar');
      window.localStorage.setItem('closed_bar_' + $(element).data('id'), true);
      $('.featured-bar').removeClass('show');
      $('body').removeClass('with-featured-bar');
    });
  });

  if (window.innerWidth >= 992) {
      AOS.init({
        once: true,
        disable: function () {
        var maxWidth = 992;
            return window.innerWidth < maxWidth;
        }
      });
  }

//  setTimeout(function(){iFrameResize({ log: false });}, 500);

  /*********search-bar***** */

  function hideNav() {
    $('.menu-toggle').removeClass("opened");
    $('.navigation').hide('fast');
    $('.navigation').removeClass('opened');
    $('body').removeClass('bodyfix');
    $('html').removeClass('bodyfix');
    $('.main-wrapper').removeClass('bodyfix');
  }


  $('.styled-tables table').wrap('<div class="responsive-table"></div>');



  /***********nested tabs************ */
  $(".nav-tabs.main_tabs a").click(function (e) {
    e.preventDefault();
    $('.nav-tabs.main_tabs li').removeClass('active');
    $(this).parent().addClass('active');
    $('.tab-content .tab-pane .nav.nav-tabs li').removeClass('active');
    $('.tab-content .tab-pane.active .nav.nav-tabs li:first').addClass('active');
    // $('.tab-content .tab-pane.active .nav-tabs li:first a').addClass('active');

    setTimeout(function () {
      var active_tab = $('.tab-content .tab-pane.active').attr("data-id");
      //console.log(active_tab);
      $('.tab-content .tab-description').removeClass('active in');
      $('.tab-content #' + active_tab).addClass('active');



      $('.tab-content .tab-pane.active .nav.nav-tabs li:first').addClass('active');

      $(".tab-description .description-block ").hide();
      $(".tab-description.active .description-block:first").css('display', 'block');
    }, 200);
  });
  $(".tab-content .nav-tabs li a").click(function (e) {
    e.preventDefault();
    $('.tab-content .tab-pane .nav-tabs li').removeClass('active');
    $(this).parent().addClass('active');
    setTimeout(function () {
      var description_tab = $('.tab-content .nav-tabs li.active a').attr("href");
      //console.log(description_tab);
      $(".tab-description .description-block ").hide();
      $(description_tab).css('display', 'block');
    }, 100);
  });

  /***********navigation************ */
  $('.menu-toggle').click(function () {
    $('.menu-toggle').toggleClass("opened");
    $('.navigation').fadeToggle('fast');
    $('.navigation').toggleClass('opened');
    $('body').toggleClass('bodyfix');
    $('html').toggleClass('bodyfix');
    $('.main-wrapper').toggleClass('bodyfix');
    $('.mega-menu').collapse('hide');
  });


  /***********megamenu***
  $('.navigation nav ul li').hover(function(){
    $(this).find('.mega-menu').fadeToggle('');
    $(this).find('.mega-menu').toggleClass('opened');
  });
  *** */

  /*********megamenu********** */
  $('.navigation nav ul li').on('mouseover',function () {
    if ($(window).width() > 1199){
      $(this).find('.mega-menu').addClass('show');
    }
  });

  $('.navigation nav ul li').on('mouseout',function () {
    if ($(window).width() > 1199){
      $(this).find('.mega-menu').removeClass('show');
    }
  });

  $('.navigation nav ul li a').on('focus', function(){
    if ($(window).width() > 1199) {
      var parent = $(this).parents('.subdropdown');
      parent.trigger('mouseover');
      $(this).parents('nav > ul').children().each(function () {
        if ($(this).attr('id') !== $(parent).attr('id')) {
          $(this).trigger('mouseout');
        }
      });
    }
  });

  $('.navigation nav ul li.subdropdown > a').on('click', function (){
    var open_page = $(this).parent().data('open-page');
    if (window.outerWidth > 1199 && open_page.length > 0) {
      window.location.href = open_page;
      return false;
    }
  });

  /*******language switch******* */
  $(".switch input[type='checkbox']").click(function () {
    $('.switch-container .name').toggleClass('selected');
    window.location = $('.switch').data('langlink');
  });


  /************experience-slider************ */

  $('.experience-slider').slick({
    /*centerMode: true,*/
    centerPadding: '0',
    slidesToShow: 2,
    loop: true,
    autoplay: false,
    autoplaySpeed: 700,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      }
    ]
  });


  /************experience-slider************ */

  $('.experience-slider1').slick({
    /*centerMode: true,*/
    centerPadding: '0',
    slidesToShow: 2,
    loop: true,
    autoplay: true,
    autoplaySpeed: 700,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      }
    ]
  });

  /************journey-slider************ */
  $('.journey-slider').slick({
    centerMode: true,
    centerPadding: '10px',
    slidesToShow: 2,
    loop: true,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1
        }
      }
    ]
  });


  // $(window).on("load resize", function () {

  // Smooth scrolling using jQuery easing
  $('.accept-payments .left-links a, .security-core .accordian-container .card-body li a[href*="#contact--form"], .banner a[href*="#contact--form"]').click(function () {
    var navHeight;
    var target = $(this.hash);
    if ($(window).width() > 1199) {
      navHeight = $(".header-top").outerHeight();
      if ( $(".featured-bar").length > 0 ) {
        navHeight += $(".featured-bar").outerHeight();
      }
    }
    else {
      navHeight = $("header").outerHeight();
    }

    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - navHeight
        },
        1000
      );
      return false;
    }
  });

  // })




  /******Target Section on Scoll - Active Class*****/
  $('.accept-payments').each(function () {
    $('body').scrollspy({ target: '#navbar-left', offset: 150 });
  });


  $('.tab-content .tab-pane.active .nav.nav-tabs li:first').addClass('active');
  var active_tab = $('.tab-content .tab-pane.active').attr("data-id");
  $('.tab-content #' + active_tab).addClass('active');
  setTimeout(function () {
    var description_tab = $('.tab-content .nav-tabs li.active a').attr("href");
    //console.log(description_tab);
    $(".tab-description .description-block ").hide();
    $(description_tab).css('display', 'block');
  }, 500);

  $("ul.nav-tabs:not(.mrm-featured-menu) a").click(function (e) {
    e.preventDefault();
    $(this).tab("show");
  });


  $(window).on('scroll',function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 10) {
        $("body").addClass("sticky-header");
      }
      else {
        $("body").removeClass("sticky-header");
      }
  }).trigger('scroll');

  /**********************sticky nav header*******
  if ($(window).width() > 992) {

    const body = document.body;
    const triggerMenu = document.querySelector("header");
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;


    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
      }

      if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
      } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
      ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
      }
      lastScroll = currentScroll;
    });

  }
****** */
  /*************accordian****
  $('#gdpr-compliance').on('shown.bs.collapse', function(e) {
    var $panel = $(this).closest('.card');
    var headerHeight = $("header").height();
    $('html,body').animate({
      scrollTop: $panel.offset().top - headerHeight
    }, 500);
  });
 *********accordian**********/

  $(".solutionsSecurityPciCompliance #accordion .card .collapse").attr("data-parent", "");

  /**************tabs in mobile ************/

  $('.who-you-are .tab-content .tab-pane .tabbable.tabs-inner .nav.nav-tabs li').click(function () {
    if ($(window).width() < 768) {
      $(this).nextAll().toggleClass('open');
      $(this).prevAll().toggleClass('open');
      $(this).toggleClass('open');
      $(this).parent().toggleClass('opened');
    }
  });



  window.onresize = function () {
    if ($(window).width() >= 767) {
      // Get an array of all element heights
      $(".payment-connections1").map(function () {
        var elementHeights = $(this).find('.tabs-container .tab-pane').map(function () {
          return $(this).height();
        }).get();
        // Math.max takes a variable number of arguments
        // apply is equivalent to passing each height as an argument
        var maxHeight = Math.max.apply(null, elementHeights);

        // Set each height to the max height
        $(this).find('.tabs-container .tab-pane').height(maxHeight);
      });

    } else {
      $(".payment-connections1 .tabs-container .tab-pane").height("auto");
    }
  }

});

function filterTag(url){
	window.location = url;
}

function ifarmeLoader(element) {
  console.log('ifarmeLoader');
  element.setAttribute('src', element.getAttribute('data-src') + '?page_name='+encodeURIComponent(window.location.href));
}


$(".import-event .dropdown").click(function() {
    $(".share-dropdown-menu", this).toggleClass("show");
});

$('body:not(.import-event .dropdown)').click(function(e){
  $('.share-dropdown-menu').removeClass('show');
});
